module.exports = __webpack_public_path__ + "assets/quiz-white.91625e63.svg";